import Vuex from 'vuex';
import Vue from 'vue';
import createPersistedState from "vuex-persistedstate";
import auth from './modules/auth';
import axios from 'axios';
// Load Vuex
Vue.use(Vuex);

const salvareInitiala = JSON.parse(localStorage.getItem('cart')) || [];

// Create store
const store = new Vuex.Store({
  modules: {
    auth
  },
  plugins: [createPersistedState()],
  state: {
      products: null,
      cart: salvareInitiala,
      toast: { 
          text: "",
          show: false
      },
      products_id : [],
      status_bucatarie : 1,
      tip_tranzactie : 2,
      durata_livrare_state : 0,
      eroare_generala_paid : '',
      location_shop : ''
  },
  getters: {
      cartSize: (state) => {
          return state.cart.length;
      },
      cartTotalAmount: (state) => {
          return state.cart.reduce((total, product) => {
              return total + (product.price * product.quantity);
          }, 0);
      },
      toast: (state) => {
          return state.toast;
      }
  },
  mutations: {
      seteazaIdApp : (state, valoare) => {
        state.location_shop = valoare;
      },
      seteazaProduseFavorite : (state, valoare) => {
        state.products_id = valoare;
      },
      seteazaTipTranzactie : (state, valoare) => {
        state.tip_tranzactie = valoare;
      },
      seteazaEroare : (state, valoare) => {
        state.eroare_generala_paid = valoare;
      },
      golesteCos(state) {
        state.cart = [];
        localStorage.setItem('cart', JSON.stringify([]));
      },
      seteazaDurataLivrare : (state, valoare) => {
        state.durata_livrare_state = valoare;
      },
      seteazaStatusBucatarie: (state,valoare) => {
          state.status_bucatarie = valoare;
      },
      setUpProducts: (state, productsPayload) => {
          //sets the state's  products property to the products array recieved as payload
          state.products = productsPayload;
      },
      addToCart: (state, productId) => {
          //find the product in the products list
          let product = state.products.find((product) => product.id === productId);
          //find the product in the cart list
          let cartProduct = state.cart.find((product) => product.id === productId);

          if (cartProduct) {
              //product already present in the cart. so increase the quantity
              cartProduct.quantity++;
          } else {
              state.cart.push({
                  // product newly added to cart
                  ...product,
                  stock: product.quantity,
                  quantity: 1,
              });
          }
          //reduce the quantity in products list by 1
          product.quantity--;
      },
      removeFromCart: (state, productId) => {
          //find the product in the products list
          let product = state.products.find((product) => product.id === productId);
          //find the product in the cart list
          let cartProduct = state.cart.find((product) => product.id === productId);

          cartProduct.quantity--;
          //Add back the quantity in products list by 1
          product.quantity++;
      },
      deleteFromCart: (state, productId) => {
          //find the product in the products list
          let product = state.products.find((product) => product.id === productId);
          //find the product index in the cart list
          let cartProductIndex = state.cart.findIndex((product) => product.id === productId);
          //srt back the quantity of the product to intial quantity
          product.quantity = state.cart[cartProductIndex].stock;
          // remove the product from the cart
          state.cart.splice(cartProductIndex, 1);
      },
      showToast: (state, toastText) => {
          state.toast.show = true;
          state.toast.text = toastText;
      },
      hideToast: (state) => {
          state.toast.show = false;
          state.toast.text = "";
      },
        removeFromCartByIndex(state, index) {
            state.cart.splice(index, 1);
        },
      adaugaInCos(state, produs) {
        const produse_extra = produs.produse_extra || [];
        const optiuni_extra_produs = produs.optiuni_extra_produs || [];
        const nota = produs.nota_produs_individual || '';

        // 👇 AICI adaugi log-ul
        console.log("Compar", {
            id: produs.id_produs,
            produse_extra,
            optiuni_extra_produs,
            nota,
            cart: state.cart
        });

        const produsDeja = state.cart.find(item => {
            return item.id_produs === produs.id_produs &&
            JSON.stringify(item.produse_extra || []) === JSON.stringify(produse_extra) &&
            JSON.stringify(item.optiuni_extra_produs || []) === JSON.stringify(optiuni_extra_produs) &&
            (item.nota_produs_individual || '') === nota;
        });

        if (produsDeja) {
            produsDeja.cantitate_produs += produs.cantitate_produs;
        } else {
            state.cart.push({
            ...produs,
            produse_extra,
            optiuni_extra_produs,
            nota_produs_individual: nota,
            });
        }

        localStorage.setItem('cart', JSON.stringify(state.cart));
    },
    sincronizeazaCart(state) {
        const cartLocal = JSON.parse(localStorage.getItem('cart')) || [];
        state.cart = cartLocal;
    },
      stergeDinCos(state, index) {
        state.cart.splice(index, 1);
        localStorage.setItem('cart', JSON.stringify(state.cart));
      },
  },
  actions: {
      
  }
});

// Watcher pentru salvarea automată a coșului
store.watch(
  (state) => state.cart,
  (cart) => {
    localStorage.setItem('cart', JSON.stringify(cart));
  },
  { deep: true }
);

export default store;